export const breadcrumbs = {
	queryParamsToRemove: ["page[number]"],
};
